/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItems_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartLayout_user$ref: FragmentReference;
export type CartLayout_user = {|
  +isVerifiedTrade: ?boolean,
  +$fragmentRefs: CartItems_user$ref,
  +$refType: CartLayout_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartLayout_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItems_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c5fbeaea65ab8b27d4b13452eea29968';
module.exports = node;
